import { fetchConToken } from '../helpers/fetch';

const ArchivosContratacionesService = {
    getArchivosContratos : (fechaDesde, fechaHasta, tipoArchivo) => {
        return fetchConToken(`ArchivosContrataciones?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}&tipoArchivo=${tipoArchivo}`)
    },
    getParametrosContratos:()=>{
        return fetchConToken(`ParametrosContrataciones`)
    }
}

export {ArchivosContratacionesService as default}